import React, { useEffect, useState } from "react";
import "../Components/CSS/Global.css";
import { login } from "webtonative/SocialLogin/google";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const benefitsData1 = [
    { id: 1, title: "Website", description: "A 10-page website for your business.", icon: "fa-globe", price: 499 },
    { id: 2, title: "Easy Dashboard", description: "Manage your business from one place.", icon: "fa-chart-line", price: 31 },
    { id: 3, title: "Customer Manager", description: "Keep track of customers & sales.", icon: "fa-user-check", price: 31 },
    { id: 4, title: "Staff Panel", description: "Your team can manage their tasks easily.", icon: "fa-users-cog", price: 31 },
    { id: 5, title: "Online Store", description: "Sell your products & services online.", icon: "fa-store", price: 31 },
    { id: 6, title: "Safe Payments", description: "Accept money online securely.", icon: "fa-shield-alt", price: 31 },
    { id: 7, title: "Auto Salary System", description: "Pay your employees on time.", icon: "fa-solid fa-indian-rupee-sign", price: 31 },
    { id: 8, title: "Attendance Tracking", description: "Employees check in with a selfie & location.", icon: "fa-clock", price: 31 },
    { id: 9, title: "Stock & Orders", description: "Keep track of products & suppliers.", icon: "fa-boxes", price: 31 },
    { id: 10, title: "Reports", description: "Get detailed performance reports.", icon: "fa-file-alt", price: 31 },
    { id: 11, title: "Leads Manager", description: "Track and convert potential customers.", icon: "fa-bullseye", price: 31 },
    { id: 12, title: "Billing & Transactions", description: "Keep all money records in one place.", icon: "fa-receipt", price: 31 },
    { id: 13, title: "Live Location Tracking", description: "See where your field employees are.", icon: "fa-map-marker-alt", price: 31 },
    { id: 14, title: "Auto Reminders", description: "Get alerts for subscription renewals.", icon: "fa-bell", price: 31 },
    { id: 15, title: "WhatsApp Chat", description: "Talk to customers directly.", icon: "fa-brands fa-whatsapp", price: 31 },
    { id: 16, title: "Auto Invoices", description: "Create and manage invoices easily.", icon: "fa-file-invoice", price: 31 },
    { id: 17, title: "Instant Alerts", description: "Send important messages to employees & customers.", icon: "fa-exclamation-circle", price: 31 },
    { id: 18, title: "Expense Tracker", description: "Manage business costs.", icon: "fa-wallet", price: 31 },
    { id: 19, title: "Employee Rewards", description: "Give points for good performance.", icon: "fa-gift", price: 31 }
];

const FeaturesRealEsate = ({ fetchCartData, setTriggerClick }) => {
    const [addedItems, setAddedItems] = useState(new Set());
    const [benefitsData, setBenefitsData] = useState([]);
    const [additionalBenefits, setAdditionalBenefits] = useState([]);
    const login = JSON.parse(localStorage.getItem("login")) || false;
    const navigate = useNavigate();
    // const handleAddToCart = async (benefit) => {
    //     try {


    //         const response = await fetch('https://100billionrealestate.com/cart', {
    //             method: 'POST',
    //             headers: { "Content-Type": "application/json" },
    //             body: JSON.stringify({

    //                 item_id: benefit.id,
    //                 product_title: benefit.title,
    //                 product_description: benefit.description,
    //                 product_icon: benefit.icon,
    //                 product_ogprice: benefit.price,
    //                 product_price: benefit.sale_price || benefit.price || 0,
    //                 product_quantity: 1,
    //                 user_id: login.emplyee_ID,
    //             })
    //         });

    //         const result = await response.json();
    //         if (response.ok) {
    //             toast.success(`${benefit.title} added to cart!`);
    //             fetchCartData()
    //             setTriggerClick(true)
    //             setTimeout(() => setTriggerClick(false), 100);
    //             // addToCart(benefit);
    //             // setAddedItems(prev => new Set(prev).add(benefit.title));
    //         } else {
    //             toast.error(result.message || "Already in cart");
    //             // alert(result.message || "Already added");
    //         }
    //     } catch (error) {
    //         toast.error("Error adding to cart:", error);
    //         console.error("Error adding to cart:", error);
    //     }
    // };


    const fetchCartItems = async () => {
        if (!login || !login.emplyee_ID) return;

        try {
            const res = await fetch(`https://100billionrealestate.com/cart/getcartadded/${login.emplyee_ID}`);
            const data = await res.json();

            const itemSet = new Set(data.map(item => item.item_id));
            setAddedItems(itemSet);
        } catch (err) {
            console.error("Error fetching cart items", err);
        }
    };

    console.log(addedItems);
    const handleAddToCart = async (benefit) => {
        if (!login || !login.emplyee_ID) {
            toast.error("Please log in first!");
            localStorage.setItem("checkstate", true)
            navigate("/login"); // <-- redirect to login page
            return;
        }

        try {
            const response = await fetch('https://100billionrealestate.com/cart', {
                method: 'POST',
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    item_id: benefit.id,
                    product_title: benefit.title,
                    product_description: benefit.description,
                    product_icon: benefit.icon,
                    product_ogprice: benefit.price,
                    product_price: benefit.sale_price,
                    product_quantity: 1,
                    user_id: login.emplyee_ID,
                })
            });

            const result = await response.json();
            if (response.ok) {
                toast.success(`${benefit.title} added to cart!`, {
                    autoClose: 900,
                    position: "top-center",
                });

                fetchCartData();
                fetchCartItems();
                setTriggerClick(true);
                setTimeout(() => setTriggerClick(false), 100);
            } else {
                toast.error(result.message || "Already in cart", {
                    autoClose: 900,
                    position: "top-center",
                });
            }
        } catch (error) {
            toast.error("Error adding to cart");
            console.error("Error adding to cart:", error);
        }
    };

    const fetchBenefitsData = async () => {
        try {
            const response = await fetch('https://100billionrealestate.com/features-realestate/getall/details');
            const data = await response.json();
            const activeItems = data.filter(item => item.status === "Active");

            // Split based on additional = "1" or "0"
            // const normal = activeItems
            //     .filter(item => (item.additional === "0" || item.additional === null))
            //     .sort((a, b) => parseInt(a.position) - parseInt(b.position));

            // const additional = activeItems
            //     .filter(item => item.additional === "1")
            //     .sort((a, b) => parseInt(a.position) - parseInt(b.position));

            setBenefitsData(activeItems);
            // setAdditionalBenefits(additional);
        } catch (error) {
            console.error("Error fetching benefits data:", error);
        }
    }

    console.log(additionalBenefits)

    useEffect(() => {
        fetchBenefitsData();
        fetchCartItems();
    }, []);

    return (
        <>
            {
                benefitsData.length > 0 && <div className="features">
                    <h1 className="benefits-title">Powerful Features</h1>
                    <div className="benefits-container">
                        {benefitsData.map((benefit, index) => (
                            <div className="benefit-card" key={index}>
                                <div className="benefits-icons">
                                    <i className={`fa ${benefit.icon} benefit-icon`}></i>
                                    {/* <div className="cart-icon-container">
                                    <i
                                        className={`fa-solid fa-cart-plus benefits-add-to-cart-icon ${addedItems.has(String(benefit.id))
                                            ? 'added' : ''}`}
                                        onClick={() => !addedItems.has(benefit.id) && handleAddToCart(benefit)}
                                        title={addedItems.has(benefit.id) ? "Already in cart" : "Add to cart"}
                                        style={{ cursor: addedItems.has(benefit.id) ? "not-allowed" : "pointer", opacity: addedItems.has(benefit.id) ? 0.6 : 1 }}
                                    ></i>
                                </div> */}
                                </div>
                                <div className="benefit-content">
                                    <h3>{benefit.title}</h3>
                                    <p>{benefit.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            }
            {additionalBenefits.length > 0 &&
                <div className="benefits">
                    <h1 className="benefits-title">Additional Features</h1>
                    <div className="benefits-container">
                        {additionalBenefits.map((benefit, index) => (
                            <div className="benefit-card" key={index}>
                                <div className="benefits-icons">
                                    <i className={`fa ${benefit.icon} benefit-icon`}></i>
                                    <div className="cart-icon-container">
                                        <i
                                            className={`fa-solid fa-cart-plus benefits-add-to-cart-icon ${addedItems.has(String(benefit.id))
                                                ? 'added' : ''}`}
                                            onClick={() => !addedItems.has(benefit.id) && handleAddToCart(benefit)}
                                            title={addedItems.has(benefit.id) ? "Already in cart" : "Add to cart"}
                                            style={{ cursor: addedItems.has(benefit.id) ? "not-allowed" : "pointer", opacity: addedItems.has(benefit.id) ? 0.6 : 1 }}
                                        ></i>
                                    </div>
                                </div>
                                <div className="benefit-content">
                                    <h3>{benefit.title}</h3>
                                    <p>{benefit.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            }
        </>
    );
};

export default FeaturesRealEsate;